import React from 'react'
import base from './base.css'
import Container from '../components/container'
import Navigation from '../components/navigation'
import Helmet from 'react-helmet'
import favicon from '../img/favicon.ico';
import Footer from '../components/footer'
import { withPrefix, Link } from 'gatsby-link'

class Template extends React.Component {
  componentDidMount() {
      var url = new URL(location.href);
     var x = new URLSearchParams(url.search);
     if (x!=null && x.get("view")=='mobile')
     {
       document.getElementById('divnavigation').style.display='none';
       document.getElementById('divfooter').style.display='none';
     }
     else {
       document.getElementById('divnavigation').style.display='block';
       document.getElementById('divfooter').style.display='block';
     }
    
  }
  render() {
    const { location, children, data } = this.props
    let header

    let rootPath = `/`
    if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
      rootPath = __PATH_PREFIX__ + `/`
    }

    return (
      <Container>
        <Helmet 
          title = {data.site.siteMetadata.title}
          keyword = {data.site.siteMetadata.keyword}
          description = {data.site.siteMetadata.description}
          link={[
            { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
        ]}>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="keywords" content="" />
            <meta name="description" content="" />
            <meta name="author" content="Exodus One Labs" />
            <script src="https://js.churchcenter.com/modal/v1"></script>
            <script src="https://www.eventbrite.com/static/widgets/eb_widgets.js"></script>
            <script async src="https://www.googletagmanager.com/gtag/js?id=UA-167960079-1"></script>
            <script src={withPrefix('eventbrite-script.js')} type="text/javascript" />
            <script src={withPrefix('google-analytic.js')} type="text/javascript" />

        </Helmet>
        <div id="divnavigation">
        <Navigation />
        </div>
        <div style={{ background:'black', maxWidth: '100%', margin: '0 auto' }}>
            {children()}
        </div>
        <div style={{ maxWidth: 1200, padding:25, background: '#3c3c3c',color: 'white' ,  margin: '0 auto' }} id="divfooter"> 
          <Footer />
        </div>
      </Container>
    )
  }
}

export default Template

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
        keyword
        description
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js